

const KLOOK_AID = import.meta.env.VITE_KLOOK_AID || "116395";

export const getKlookSearchUrl = (activityTitle, cities = '') => {
  const citiesStr = Array.isArray(cities)
    ? cities.filter(Boolean).join(' → ')
    : cities;
  const query = `Explore ${activityTitle}${citiesStr ? ` ${citiesStr}` : ''}`.trim();

  const params = new URLSearchParams({
    search_landing: 'true',
    query,
    aid: KLOOK_AID,
    utm_medium: 'affiliate-alwayson',
    utm_source: 'non-network',
    utm_campaign: KLOOK_AID,
    utm_term: '',
  });

  return `https://www.klook.com/search/result/?${params.toString()}`;
};

export const getKlookDestinationUrl = (cities) => {
  const citiesStr = Array.isArray(cities)
    ? cities.filter(Boolean).join(' → ')
    : cities;
  const query = `Explore ${citiesStr}`.trim();

  const params = new URLSearchParams({
    search_landing: 'true',
    query,
    aid: KLOOK_AID,
    utm_medium: 'affiliate-alwayson',
    utm_source: 'non-network',
    utm_campaign: KLOOK_AID,
    utm_term: '',
  });

  return `https://www.klook.com/search/result/?${params.toString()}`;
};

const KLOOK_MIN_COST = 100;

export const isBookableActivity = (activity) => {
  if (!activity) return false;

  const bookableCategories = ['sightseeing', 'adventure'];
  if (!bookableCategories.includes(activity.category)) return false;

  const raw = String(activity.estimatedCost ?? '').trim();
  if (!raw) return false;
  const lower = raw.toLowerCase();
  if (lower === 'free' || lower === '—' || lower === '-' || lower.startsWith('free')) return false;
  if (lower.includes('included') || lower.includes('check locally') || lower.includes('check on') ||
      lower.includes('varies') || lower.includes('n/a')) return false;

  const match = raw.match(/\d[\d,]*/);
  if (!match) return false;
  const value = parseInt(match[0].replace(/,/g, ''), 10);
  if (!Number.isFinite(value) || value <= KLOOK_MIN_COST) return false;

  return true;
};

export const fetchKlookActivities = async (query, city) => {

  return null;
};

export const isKlookApiAvailable = () => {
  return !!import.meta.env.VITE_KLOOK_API_KEY;
};

export default {
  getKlookSearchUrl,
  getKlookDestinationUrl,
  isBookableActivity,
  fetchKlookActivities,
  isKlookApiAvailable,
  KLOOK_AID,
};
